module.exports = {
	LICENCE_KEY: "AquaDBBEBeta"
}



// WEBPACK FOOTER //
// ./src/login/constants/LoginConstants.js